import useCalendarOnlyForContext from '@/hooks/calendar/useCalendarOnlyForContext';
import { createContext } from 'react';

// Context that provides all the calendar data functionality
const CalendarContext = createContext<
	ReturnType<typeof useCalendarOnlyForContext>
>({
	calendar: undefined,
	getDatesFromSpecies: () => [],
	getIsSpeciesInCalendar: () => false,
	speciesOfTheWeekDate: undefined,
	monthlyCalendar: undefined,
	isLoading: false,
	error: undefined,
});

export default CalendarContext;
